import { FC } from "react";
import { Box, Table } from "@radix-ui/themes";
import { Schedule } from "@/models/database/event/Events.model";
import DateObject from "react-date-object";

interface SingleEventScheduleProps {
  zoneId?: string;
  eventSlug?: string;
  schedule?: Schedule[];
}

export const SingleEventSchedule: FC<SingleEventScheduleProps> = ({
  schedule,
}): JSX.Element => {
  // Sort the schedule by startDate and filter out the past events
  const sortedSchedule = schedule
    ?.filter((item) => {
      const endDate = new DateObject(item.endDate.toDate());
      const now = new DateObject();
      return now <= endDate;
    })
    .sort((a, b) => {
      const startDateA = new DateObject(a.startDate.toDate());
      const startDateB = new DateObject(b.startDate.toDate());
      return startDateA.toDate().getTime() - startDateB.toDate().getTime();
    });

  return (
    <Box>
      <Table.Root>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeaderCell>Date</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Time</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Activity</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>Location</Table.ColumnHeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {sortedSchedule.map((data, index) => {
            const today = new DateObject();
            const startDate = new DateObject(data.startDate.toDate());
            const endDate = new DateObject(data.endDate.toDate());
            const startTime = startDate.format("HH:mm");
            const endTime = endDate.format("HH:mm");
            const isLive = today > startDate && today < endDate;

            return (
              <Table.Row
                key={index}
                className={isLive && "schedule schedule--active"}
                style={{
                  position: "relative",
                }}
              >
                <Table.RowHeaderCell>
                  {startDate.format("DD.MM.YYYY")}
                </Table.RowHeaderCell>
                <Table.RowHeaderCell
                  className={
                    isLive && "schedule schedule__cell schedule__cell--active"
                  }
                >
                  {isLive ? "Live now" : `${startTime} - ${endTime}`}
                </Table.RowHeaderCell>
                <Table.Cell>{data.activity}</Table.Cell>
                <Table.Cell>{data.location}</Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table.Root>
    </Box>
  );
};
